import axios from "axios"

const baseUrl = process.env.VUE_APP_API_URL

const vendors = 
{
    namespaced: true,
    state: {
        vendors: [],
        vendor: {}
    },
    mutations: {
        SET_VENDORS(state, data)
        {
            state.vendors = data
        },
        SET_VENDOR(state, data)
        {
            state.vendor = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'GetAllVendors')
          .then(res => {
              commit('SET_VENDORS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteVendor ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id)
            .catch(error => console.log(error))
          },
          updateVendor({ commit }, vendor){
            return axios
            .post(baseUrl+'AddUpdateVendor', vendor)
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getVendor ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id)
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewVendor ({ commit }, vendor) {
            return axios
            .post(baseUrl+'AddUpdateVendor', vendor)
            .then(res => {
                console.log(res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default vendors